import React from 'react'
import { useMeQuery } from 'gql/graphql'
import { initializeApollo } from '@gql/client'
import { PAGINA } from 'utils/queries'
import { PaginaType } from 'utils/types'
import MyAccountDatiTemplate from 'components/templates/MyAccountDatiTemplate/MyAccountDatiTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

interface Props {
  pagina: PaginaType
}

const InformazioniPersonaliPage = ({ pagina }: Props) => {
  const { data, loading, error } = useMeQuery()

  if (error) {
    return <p>{error}</p>
  }

  return (
    <MyAccountDatiTemplate
      pagina={pagina}
      utente={
        {
          ...data?.me,
        } || null
      }
    />
  )
}

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'informazioni-personali' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 5,
  }
}, '/dashboard/informazioni-personali')

InformazioniPersonaliPage.loginRequired = true

export default InformazioniPersonaliPage
